import styled from "styled-components";

export const FormCardWrapper = styled.div`
  margin-top: 10px;
  padding: 0 30px;
  box-shadow: 0 10px 17px 10px rgba(0, 0, 0, 0.2);
  height: 90%;
  width: 80%;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const FormHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 20%;
  width: 100%;
`;

export const FormContentWrapper = styled.div`
  height: 80%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
